import type { FC } from 'react';

import { getRoundConfig } from 'app/config/videogameSpecific.config.helper';
import { withBackgroundImage } from 'app/utils/style';
import { getRounds, getTotalScores, type RoundForComputation } from 'app/utils/rounds';
import { getCDNUrl } from 'app/utils/api_url';

import RoundsTimeline from './RoundsTimeline';
import style from './style.module.scss';

interface Props {
  rounds: RoundForComputation[];
  variation: 'cs-2' | 'cs-go' | 'valorant';
  teamIds: [number, number];
  map?: GameMap;
  opponents: GameOpponent[];
}

const RoundsRecap: FC<Props> = ({ rounds, variation, teamIds, map, opponents }) => {
  const roundConfig = getRoundConfig(variation);

  const { halfgroups, overtime } = getRounds(rounds, teamIds, roundConfig);
  const [team1Score, team2Score] = getTotalScores(opponents, teamIds);

  return (
    <>
      <div
        className={style.scoresContainer}
        style={map ? withBackgroundImage(getCDNUrl(map.image_url)) : {}}
      >
        <div className={style.scoresBackgroundProtection}>
          <div className={style.totalScore}>
            {team1Score}:{team2Score}
          </div>
          <div className={style.roundsScores}>
            {halfgroups.map(({ teams: [team1, team2] }, index) => (
              <span key={index} className={style.groupScore}>
                <span className={style[team1.side ?? 'scoreDefault']}>{team1.score}</span>,
                <span className={style[team2.side ?? 'scoreDefault']}>{team2.score}</span>
              </span>
            ))}
            {overtime && (
              <span className={style.groupScore}>
                <span>{overtime.teamsScore[0]}</span>,<span>{overtime.teamsScore[1]}</span>
              </span>
            )}
          </div>
        </div>
      </div>

      <div className={style.timelinesContainer}>
        {/* Half groups */}
        <div className={style.halfgroupsContainer}>
          {halfgroups.map((group, index) => {
            const key = `halfgroup-${index}`;
            return (
              <RoundsTimeline
                key={key}
                groupkey={key}
                roundGroup={group}
                size={roundConfig.round_group_size}
              />
            );
          })}
        </div>
        {/* Overtime */}
        {overtime && (
          <div className={style.overtimeContainer}>
            {overtime.roundGroups.map((group, index) => {
              const key = `overtime-${index}`;
              return (
                <RoundsTimeline
                  key={key}
                  groupkey={key}
                  roundGroup={group}
                  size={roundConfig.overtime_size}
                />
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

RoundsRecap.displayName = 'RoundsRecap';

export default RoundsRecap;
